import { render, staticRenderFns } from "./ComunicacionesExternasRenderer.vue?vue&type=template&id=0ec24127"
import script from "./ComunicacionesExternasRenderer.vue?vue&type=script&lang=js"
export * from "./ComunicacionesExternasRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports